var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0.5C12.8037 0.5 7.75 5.55371 7.75 11.75C7.75 17.9463 12.8037 23 19 23C25.1963 23 30.25 17.9463 30.25 11.75C30.25 5.55371 25.1963 0.5 19 0.5ZM19 23C8.67285 23 0.25 31.4229 0.25 41.75H4C4 33.4443 10.6943 26.75 19 26.75C27.3057 26.75 34 33.4443 34 41.75H37.75C37.75 31.4229 29.3271 23 19 23ZM19 4.25C23.1602 4.25 26.5 7.58984 26.5 11.75C26.5 15.9102 23.1602 19.25 19 19.25C14.8398 19.25 11.5 15.9102 11.5 11.75C11.5 7.58984 14.8398 4.25 19 4.25Z",
    fill: "#FEFCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI12);
export default __webpack_public_path__ + "static/media/i12.f6dffee82d6b7132dd185d00eb4ba002.svg";
export { ForwardRef as ReactComponent };